export default "__VITE_ASSET__BOL_LGfo__"